import { z } from 'zod';

import { zodSuccessResponseSchema } from '../validations';

export const zodBulkApproveDlnsPayloadSchema = z.object({
  assetIds: z.array(z.string().uuid()),
  approveAll: z.boolean(),
});

export const zodBulkApproveDlnsEndpointSchema = z.tuple([
  z.literal('delivery_note'),
  z.literal('bulk'),
  z.literal('approve'),
]);

export { zodSuccessResponseSchema };
